/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PartOfSpeech = {
    Adj: 'ADJ',
    Adp: 'ADP',
    Adv: 'ADV',
    Aux: 'AUX',
    Cconj: 'CCONJ',
    Det: 'DET',
    Intj: 'INTJ',
    Noun: 'NOUN',
    Num: 'NUM',
    Part: 'PART',
    Pron: 'PRON',
    Propn: 'PROPN',
    Punct: 'PUNCT',
    Sconj: 'SCONJ',
    Sym: 'SYM',
    Verb: 'VERB',
    Space: 'SPACE',
    X: 'X'
} as const;
export type PartOfSpeech = typeof PartOfSpeech[keyof typeof PartOfSpeech];


export function PartOfSpeechFromJSON(json: any): PartOfSpeech {
    return PartOfSpeechFromJSONTyped(json, false);
}

export function PartOfSpeechFromJSONTyped(json: any, ignoreDiscriminator: boolean): PartOfSpeech {
    return json as PartOfSpeech;
}

export function PartOfSpeechToJSON(value?: PartOfSpeech | null): any {
    return value as any;
}

